import { FilterConfig } from "../Enums.js";

const Header = ({
  selectedView,
  customTheme,
  handleStatClick, // New handler to pass the clicked stat value to parent
}) => {

  const StatWidget = ({ title, stat1, stat2, stat3 = null }) => {
    const widgetStyle = {
      padding: "5px 15px 0px 15px",
      fontFamily: customTheme.fontFamily,
      backgroundColor: customTheme.headerWidgetColour,
      color: customTheme.headerTextColour,
      borderRadius: "8px",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.7)",
      position: "absolute",
      right: "20px",
      top: "10px",
      width: "300px",
      textAlign: "center",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.0em",
      cursor: "pointer", 
      textDecoration: "none"
    };

    const statsContainerStyle = {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      padding: "0px 10px",
      marginTop: "0px",
      fontSize: "0.9em",
    };
    const statsContainerBottomRowStyle = {
      width: "100%",
      padding: "0px 10px",
      marginTop: "5px",
      fontSize: "0.9em",
    };

    // HTML anchor tags for clickable stats with preventDefault to avoid scroll-to-top
    return (
      <div style={widgetStyle}>
      <span style={{ paddingBottom:"20px" }} onClick={() => handleStatClick(FilterConfig.ALL)}>
        {title.name}: {title.value}
      </span>
        <div style={statsContainerStyle}>
          <span onClick={() => handleStatClick(FilterConfig.COMPLETE)}>
            {stat1.name}: {stat1.value}
          </span>
          <span style={{  marginLeft: "10px" }} onClick={() => handleStatClick(FilterConfig.INCOMPLETE)}>
            {stat2.name}: {stat2.value}
          </span>
        </div>        
        {stat3 && stat3.name && stat3.value && ( 
          <div style={statsContainerBottomRowStyle}>
            <span onClick={() => handleStatClick(FilterConfig.SUBMITTED)}>
              {stat3.name}: {stat3.value}
            </span>
          </div>
        )}
      </div>
    );
  };
  
  const renderStats = () => {
    if (!selectedView || !selectedView.statWidget) {
      return (
        <StatWidget
          title={{ name: "-- Data Loading --", value: "--" }}
          stat1={{ name: "Stat 1", value: "--" }}
          stat2={{ name: "Stat 2", value: "--" }}
          stat3={{ name: "Stat 3", value: "--" }}  // This can be passed in loading state
        />
      );
    }
  
    const title = selectedView?.statWidget?.[0] || { name: "Stat 1", value: 0 };
    const stat1 = selectedView?.statWidget?.[1] || { name: "Stat 2", value: 0 };
    const stat2 = selectedView?.statWidget?.[2] || { name: "Stat 3", value: 0 };
    const stat3 = selectedView?.statWidget?.[3];  // Do not provide a default value for stat3
  
    // Conditionally pass stat3 only if it exists
    const widgetProps = { title, stat1, stat2 };
  
    if (stat3) {
      widgetProps.stat3 = stat3;  // Only add stat3 if it exists
    }
  
    return <StatWidget {...widgetProps} />;
  };

  return (
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        backgroundColor: customTheme.headerBackgroundColour,
        position: "relative",
        height: "120px",
        fontSize: customTheme.fontSize,
      }}
    >
      <img 
        src={customTheme.logoURL} 
        alt="Client Logo" 
        style={{
          marginTop: "25px",
          marginBottom: "25px",
          paddingLeft: "25px",
          height: "90px"
        }} 
      />
      
      {renderStats()}
    </header>
  );
};

export default Header;
